import { IProduct } from '../../../interfaces/Product.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

interface IGetProductsParams {
  searchParam?: {
    category: string;
    status: string;
    brand?: string;
    sort?: string;
    count?: number;
  };
}

export const getProducts = ({ searchParam }: IGetProductsParams): Promise<IProduct[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/market/products?${URLSearchParams}`);
};
